import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button } from 'element-react'
import { MainSectionDefault } from '../../views/includes/Wrappers'
import Spacer from '../../views/includes/Spacer'
import AppRoutes from '../../../routes/appRoutes'

const FormMessageTwoButtons = props => {
    const {
        firstButtonLabel,
        firstButtonOnClick,
        messageContent,
        messageTitle,
        sencondButtonLabel = 'Return to Dashboard',
        secondButtonLink = AppRoutes.home(),
    } = props
    return (
        <MainSectionDefault>
            <img
                className="center success-checkmark"
                src="/img/success_checkmark.svg"
            />
            <h4 className="text-center margin-bottom-small">{messageTitle}</h4>
            <p className="text-center margin-bottom-medium">{messageContent}</p>
            <div className="row">
                <div className="columns medium-4 medium-offset-2 small-12">
                    <Button
                        type="primary"
                        className="center"
                        onClick={firstButtonOnClick}
                    >
                        {firstButtonLabel}
                    </Button>
                </div>
                <Spacer className="hide-for-medium" size="small" />
                <div className="columns medium-4 small-12">
                    <Link to={secondButtonLink}>
                        <Button type="default" className="center">
                            {sencondButtonLabel}
                        </Button>
                    </Link>
                </div>
            </div>
        </MainSectionDefault>
    )
}

FormMessageTwoButtons.propTypes = {
    firstButtonLabel: PropTypes.string.isRequired,
    firstButtonOnClick: PropTypes.func.isRequired,
    messageContent: PropTypes.string.isRequired,
    messageTitle: PropTypes.string.isRequired,
    sencondButtonLabel: PropTypes.string,
    secondButtonLink: PropTypes.string,
}

export default FormMessageTwoButtons
